"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Tabs = require("./Tabs.style");

var _TabLabel = _interopRequireDefault(require("./TabLabel"));

var Tabs =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Tabs, _Component);

  function Tabs() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tabs)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setRootNode", function (node) {
      _this.rootNode = node;

      _this.setupTab(_this.props);
    });
    return _this;
  }

  (0, _createClass2.default)(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupTab(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setupTab(nextProps);
    }
  }, {
    key: "setupTab",
    value: function setupTab(props) {
      var activeIndex = props.tabs.findIndex(function (e) {
        return e.active;
      });

      if (activeIndex < 0) {
        return;
      }

      if (!this.rootNode) {
        return;
      }

      var sliderNode = this.rootNode.querySelector('.bgClass');

      if (!sliderNode) {
        return;
      }

      var vertical = props.vertical;
      var tabIndex = activeIndex + 1;
      var activeNode = this.rootNode.querySelector(".tabWrapper div:nth-child(".concat(tabIndex, ")"));

      if (vertical) {
        var offsetHeight = activeNode.offsetHeight || 0;
        var offsetTop = activeNode.offsetTop;
        sliderNode.style.height = offsetHeight + 'px';
        var translateTop = activeIndex === 0 ? 0 : offsetTop;
        sliderNode.style.transform = "translate3d(0px, ".concat(translateTop, "px, 0px)");
      } else {
        var offsetWidth = activeNode.offsetWidth || 0;
        var offsetLeft = activeNode.offsetLeft;
        sliderNode.style.width = offsetWidth + 'px';
        var translateLeft = activeIndex === 0 ? 0 : offsetLeft;
        sliderNode.style.transform = "translate3d(".concat(translateLeft, "px, 0px, 0px)");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          tabs = _this$props.tabs,
          onClick = _this$props.onClick,
          wrapperClassName = _this$props.wrapperClassName,
          size = _this$props.size,
          vertical = _this$props.vertical,
          className = _this$props.className,
          themeType = _this$props.themeType,
          isMobile = _this$props.isMobile,
          showClose = _this$props.showClose,
          closeClick = _this$props.closeClick;
      var isDarkTheme = themeType === 'dark';
      return _react.default.createElement("div", {
        ref: this.setRootNode,
        className: (0, _classnames.default)(_Tabs.tabMainWrapper, className)
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)((0, _Tabs.tabWrapperStyles)(theme, vertical, isDarkTheme), wrapperClassName, 'tabWrapper')
      }, tabs.map(function (tab) {
        return _react.default.createElement(_TabLabel.default, (0, _extends2.default)({
          key: tab.value,
          onClick: onClick,
          index: tab.active
        }, tab, {
          size: size,
          vertical: vertical,
          isDarkTheme: isDarkTheme,
          isMobile: isMobile
        }));
      }), showClose && _react.default.createElement("span", {
        onClick: closeClick,
        className: _Tabs.closeIcon
      }, _react.default.createElement(_Icon.default, {
        style: {
          fill: "".concat(isDarkTheme ? theme.color.dark.amethyst : theme.color.accent)
        },
        type: "close"
      }))), (!isDarkTheme || vertical) && _react.default.createElement("div", {
        className: (0, _classnames.default)((0, _Tabs.tabTransformWrapper)(theme, vertical, isDarkTheme), 'bgClass')
      }));
    }
  }]);
  return Tabs;
}(_react.Component);

Tabs.propTypes = {
  tabs: _propTypes.default.arrayOf(_propTypes.default.shape(_TabLabel.default.propTypes)).isRequired,
  onClick: _propTypes.default.func,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  vertical: _propTypes.default.bool,
  themeType: _propTypes.default.string,
  isMobile: _propTypes.default.bool,
  showClose: _propTypes.default.bool,
  closeClick: _propTypes.default.func
};
Tabs.defaultProps = {
  onClick: function onClick() {},
  size: 'medium',
  vertical: false,
  themeType: 'light',
  isMobile: false,
  showClose: false,
  closeClick: function closeClick() {}
};

var _default = (0, _emotionTheming.withTheme)(Tabs);

exports.default = _default;